import { useDataExplorerAppearance } from './appearanceContext';
import type { DataExplorerCheckboxProps } from './types';
import { resolveDataExplorerAppearance } from './theme';
import { cn } from './utils';

function CheckIcon() {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      className="h-3.5 w-3.5"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.5"
    >
      <path d="m5 12 4 4L19 6" />
    </svg>
  );
}

export function DataExplorerCheckbox({
  checked = false,
  icon,
  label,
  title,
  disabled = false,
  appearance,
  className,
  classNames,
  style,
  onCheckedChange,
}: DataExplorerCheckboxProps) {
  const theme = resolveDataExplorerAppearance(
    useDataExplorerAppearance(appearance),
  );

  return (
    <button
      type="button"
      title={title}
      aria-pressed={checked}
      disabled={disabled}
      className={cn(
        theme.slots.controlCheckbox,
        checked && theme.slots.actionToggleActive,
        disabled && theme.slots.actionButtonDisabled,
        classNames?.root,
        className,
      )}
      style={{
        ...theme.styles.control,
        ...(checked ? theme.styles.controlActive : undefined),
        ...(disabled ? theme.styles.controlDisabled : undefined),
        ...style,
      }}
      onClick={(event) => {
        event.stopPropagation();
        if (disabled) return;
        void onCheckedChange?.(!checked);
      }}
    >
      <span
        className={cn(
          theme.slots.controlCheckboxIndicator,
          classNames?.indicator,
          icon !== undefined && icon !== null && !checked && classNames?.icon,
        )}
      >
        {checked ? <CheckIcon /> : icon}
      </span>
      {label ? (
        <span className={cn(theme.slots.controlCheckboxLabel, classNames?.label)}>
          {label}
        </span>
      ) : null}
    </button>
  );
}
